import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable, signal, WritableSignal, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrgbrainLayoutService {
  breakpointObserver = inject(BreakpointObserver);

  static toolBarHeight = 82; // see also shared/_dimensions.scss
  static dialogDefaultWidth = 570;
  static dialogNarrowWidth = 470;
  static minDeviceWidth = 360;

  changes$: BehaviorSubject<OrgbrainLayoutService>;
  public mobile = false;
  public mobileViewSignal: WritableSignal<boolean> = signal(false);
  public smallScreenSignal: WritableSignal<boolean> = signal(false);
  public showVideo: boolean;
  video$ = new BehaviorSubject<boolean>(false);
  menuClose$ = new BehaviorSubject<boolean>(false);
  videoDiv: any;

  constructor() {
    this.changes$ = new BehaviorSubject<OrgbrainLayoutService>(this);
    this.breakpointObserver.observe(['(min-width: 570px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.mobile = false;
      } else {
        this.mobile = true;
      }
      this.changes$.next(this);
    });
    this.breakpointObserver.observe(['(min-width: 768px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.mobileViewSignal.set(false);
      } else {
        this.mobileViewSignal.set(true);
      }
      this.changes$.next(this);
    });

    this.breakpointObserver.observe(['(min-width: 860px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.smallScreenSignal.set(false);
      } else {
        this.smallScreenSignal.set(true);
      }
    });
  }

  showVideoWindow(yes: boolean) {
    this.showVideo = yes;
    this.video$.next(yes);
  }

  hideMenuIfMobile() {
    if (this.mobile) {
      this.menuClose$.next(true);
    }
  }
}
